import { useFeatureGate } from '@statsig/expo-bindings';

import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import { FeatureFlags } from '../../feature-flags/FeatureFlags';

export const useShowSproutDevTools = (): boolean => {
    const { value: enableSproutDevTools } = useFeatureGate(
        FeatureFlags.ENABLE_INTERNAL_SPROUT_DEV_TOOLS,
    );

    return !IS_PRODUCTION || enableSproutDevTools;
};
